import React, { Component } from 'react';
import './currencyInput.scss';
import PropTypes from 'prop-types';

export default class CurrencyInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      amount: '',
      isFocused: false
    };
    this.formatNumberToCurrencyFormat = this.formatNumberToCurrencyFormat.bind(this);
    this.formatCurrencyToNumberFormat = this.formatCurrencyToNumberFormat.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCurrencyFormat = this.handleCurrencyFormat.bind(this);
    this.removeZeroAsFirstChar = this.removeZeroAsFirstChar.bind(this);
    this.formatNewInput = this.formatNewInput.bind(this);
  }
  componentWillMount() {
    this.setState({ amount: this.props.inputValue });
  }

  formatNumberToCurrencyFormat(n) {
    return n.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatCurrencyToNumberFormat(n) {
    return n.toString().replace(/,/g, "").replace(/\$/g, "");
  }

  formatNewInput(symbol, value) {
    return symbol + this.formatNumberToCurrencyFormat(value);
  }

  removeZeroAsFirstChar(val) {
    return val.toString().charAt(0) === '0' ? val.substr(1) : val;
  }

  handleInputBlur(e) {
    let temp =Number(this.formatCurrencyToNumberFormat(this.state.amount));
    if(temp===0){
      this.setState({
        amount: '',
        isFocused: false
      }, e=>{
        this.props.outputValue(Number(this.formatCurrencyToNumberFormat(this.state.amount)));
      });
    } else {
      this.props.outputValue(Number(this.formatCurrencyToNumberFormat(this.state.amount)));
    }
  }

  handleInputChange(e) {
    this.handleCurrencyFormat(e);
  }

  handleInputFocus(e) {
    let temp =Number(this.formatCurrencyToNumberFormat(this.state.amount));
    if(temp===0){
      this.setState({
        amount: '',
        isFocused: true
      });
    }
  }

  handleCurrencyFormat(e) {
    let input_val = e.target.value;

    if (input_val === "") {
      input_val=0;
    } else {
      input_val = input_val !== 0 ? this.removeZeroAsFirstChar(input_val) : 0;
    }
    input_val = this.formatNumberToCurrencyFormat(input_val);
    this.setState({ amount: input_val }, e=>{
      this.handleInputBlur(e);
    });
  }

  handleOnBlur() {
    if(this.props.onBlur) {
      this.props.onBlur();
    }
  }

  render() {
    const isValueEntered=this.state.isFocused || this.state.amount.length>0;
    return (
      <div className={`currency-input-wrapper`}>
        {
          isValueEntered?<span className={`currency-symbol standard-blue`}>{this.props.currencySymbol}</span>:null
        }
        <input type="tel"
          className={`standard-blue currency-input-placeholder`}
          style={{ paddingLeft: isValueEntered?20:10 }}
          id={this.props.id}
          data-track="app-start1"
          tabIndex={this.props.tabIndex}
          pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
          value={this.state.amount}
          ref={(input) => { this.currencyInput = input; }}
          onBlur={e=>{
            this.setState({ isFocused: false });
            this.handleOnBlur();
          }}
          onChange={this.handleInputChange}
          onKeyDown={e=>{
            if(e.keyCode===13){
              e.target.blur();
            }
          }}
          placeholder={this.props.placeholder}
          onFocus={this.handleInputFocus}
          aria-label={this.props.placeholder}
          maxLength={this.props.maxLength?this.props.maxLength:40}
        />
      </div>
    );
  }
}


CurrencyInput.propTypes = {
  currencySymbol: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  outputValue: PropTypes.func,
  onBlur: PropTypes.func
};

CurrencyInput.defaultProps = {
  currencySymbol: '$',
  id: 'currency-input',
  placeholder: 'Enter Amount',
  maxLength: 40,
  outputValue: null
};
